// ================= CONFIG =================
export const CONFIG = {
  API_BASE_URL: "https://admin.myschoolling.com",
  //API_BASE_URL: "http://127.0.0.1:8000", // for local
};

// ✅ Always define AFTER CONFIG
const BASE_URL = `${CONFIG.API_BASE_URL}/v1/api`;


export const apiRequest = async (
  endpoint,
  method = "GET",
  body = null,
  token = null
) => {
  try {
    const isFormData = body instanceof FormData;

    const headers = {};

    // set JSON header if NOT FormData
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method,
      headers,
      body: body
        ? isFormData
          ? body // send as-is
          : JSON.stringify(body) // JSON only
        : null,
    });

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error(`Server error (${response.status}): unexpected response format`);
    }

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Something went wrong");
    }

    return data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};